namespace SP.Data {
    export class Tote {

        //private static toteInfo: { [toteId: string]: ToteInfo } = {};

        static async getToteInfo(toteId: string, useCache = true)  {
            //if (useCache && this.toteInfo[toteId] != null) return this.toteInfo[toteId];
            var response = await SP.get<any>("/api/v1/info/toteInfo/" + toteId);
            if (response.status == 200) return response.data as ToteInfo;// this.toteInfo[toteId] = response.data;
            else await SP.alertX(response.status + ": " + response.msg);
            return null;
        }

        static async getToteInfos(toteIds: number[], useCache = true) {
            //if (useCache && this.toteInfo[toteId] != null) return this.toteInfo[toteId];
            var response = await SP.get<any>("/api/v1/info/toteInfos/" + toteIds.join(","));
            if (response.status == 200) return response.data as ToteInfo[];// this.toteInfo[toteId] = response.data;
            else await SP.alertX(response.status + ": " + response.msg);
            return null;
        }

        static async getTempToteInfo() {
            var response = await SP.get<any>("/api/v1/info/tempToteInfo/");
            if (response.status != 200) await SP.alertX(response.status + ": " + response.msg);
            return response.data as ToteInfo;
        }

        static async getToteInfoGroupedPick(barcode: string, trolleyId: number) {
            var response = await SP.get<any>("/api/v1/info/toteInfoGroupedPick/" + barcode + "?trolleyId=" + trolleyId);
            //if (response.status != 200) await SP.alertX(response.status + ": " + response.msg);
            return response.data as ToteInfo;
        }

        static async getToteGroupInfos(): Promise<SP.ToteGroupInfo[]> {
            var response = await SP.get<any>("/api/v1/info/toteGroupInfos");
            if (response.status != 200) await SP.alertX(response.status + ": " + response.msg);
            return response.data;
        }

        static async getToteInfosByGroup(toteGroupId: string, showOnlyFree: boolean): Promise<SP.ToteInfo[]> {
            var response = await SP.get<any>("/api/v1/info/toteInfosByGroup/" + toteGroupId + "?ShowOnlyFree=" + showOnlyFree);
            if (response.status != 200) await SP.alertX(response.status + ": " + response.msg);
            return response.data;
        }

        static async getToteInfosBarcode(barcode: string, orderNumber: string): Promise<SP.ToteInfo[]> {
            var bc = encodeURIComponent(barcode);
            var response = await SP.get<any>(`/api/v1/info/toteInfosBarcode?barcode=${bc}&orderNo=${orderNumber}`);
            if (response.status != 200) await SP.alertX(response.status + ": " + response.msg);
            return response.data;
        }


        static async getActiveToteInfos(keyword: string = ''): Promise<SP.ToteInfo[]> {
            var response = await SP.get<any>("/api/v1/info/toteInfosActive?keyword=" + keyword);
            if (response.status != 200) await SP.alertX(response.status + ": " + response.msg);
            return response.data;
        }

        static async getOrderToteInfos(orderId: string = ''): Promise<SP.ToteInfo[]> {
            var response = await SP.get<any>("/api/v1/info/toteInfosOrder?orderId=" + orderId);
            if (response.status != 200) await SP.alertX(response.status + ": " + response.msg);
            return response.data;
        }

        static async getReadyToteInfos(): Promise<SP.ToteInfo[]> {
            var response = await SP.get<any>("/api/v1/info/toteInfosReady");
            if (response.status != 200) await SP.alertX(response.status + ": " + response.msg);
            return response.data;
        }

        static async getMoveToteInfos(): Promise<SP.ToteInfo[]> {
            var response = await SP.get<any>("/api/v1/info/toteInfosMove");
            if (response.status != 200) await SP.alertX(response.status + ": " + response.msg);
            return response.data;
        }

        static async getPendingToteInfos(): Promise<SP.ToteInfo[]> {
            var response = await SP.get<any>("/api/v1/info/toteInfosPending");
            if (response.status != 200) await SP.alertX(response.status + ": " + response.msg);
            return response.data;
        }
    }
}